import React, { useEffect, useState } from "react";
import "./SideNav.scss";

// 우측 고정 네비게이션. 섹션과 프로젝트 블록으로 바로 이동한다.
const ITEMS = [
  { id: "profile", label: "About" },
  { id: "certifications", label: "Certificates" },
  { id: "project-aivo", label: "aivo", project: true },
  { id: "project-globa", label: "Globa", project: true },
  { id: "project-perfectfit", label: "PerfectFit", project: true },
  { id: "project-forde", label: "Forde", project: true },
  { id: "project-algorithm", label: "Algorithm", project: true },
  { id: "project-ysy", label: "YSY", project: true },
  { id: "project-codemong", label: "CodeMong", project: true },
  { id: "skills", label: "Skills" },
  { id: "career", label: "Career" },
];

function SideNav() {
  const [activeId, setActiveId] = useState("");

  useEffect(() => {
    let frame = 0;

    const update = () => {
      frame = 0;
      // 화면 상단 기준선을 지난 마지막 항목을 현재 위치로 본다.
      const line = window.innerHeight * 0.35;
      let current = "";
      ITEMS.forEach(({ id }) => {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top <= line) current = id;
      });
      setActiveId(current);
    };

    const onScroll = () => {
      if (!frame) frame = window.requestAnimationFrame(update);
    };

    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });

    return () => {
      if (frame) window.cancelAnimationFrame(frame);
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  return (
    <nav className="side-nav" aria-label="페이지 내 위치">
      <ul>
        {ITEMS.map((item) => (
          <li key={item.id}>
            <a
              href={`#${item.id}`}
              className={activeId === item.id ? "active" : ""}
              aria-current={activeId === item.id ? "true" : undefined}
            >
              <i aria-hidden="true" />
              <span className="side-nav-label">
                {item.project && <em>[Project]</em>}
                {item.label}
              </span>
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default SideNav;
